import { IconType } from "react-icons/lib";
import { TbDental, TbFaceMask, TbHeartbeat, TbStethoscope } from "react-icons/tb";

import { HotelPickupReasons } from "@/types/hotel.types";

import { softColors } from "./colors";

function BandageHead() {
    return (
        <svg
            className="!w-[14px] !h-[14px]  translate-x-2"
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            viewBox="0 0 256 256"
        >
            <path d="M128.1 10.7c-27 4.4-49 18.7-63.7 41.3-9 13.8-13.7 28.9-14.4 46.1l-.3 9-13.2 24.7c-7.4 13.8-13.3 25.4-13.3 26.2s.5 2 1.1 2.8c1.1 1.4 1.3 1.4 13.3 1.5l12.3.2v18.6c0 17.1.1 19 1.1 22.4 2.8 9.3 10.8 16.5 20.3 18.5 1.9.4 10.6.6 23.4.6h20.4v10.2c0 9.4.1 10.2 1.2 11.6 1.5 1.9 4.5 2 6.2.3 1.1-1.1 1.1-1.9 1.1-14.6 0-10.8-.2-13.7-.8-14.6-.8-1-1.9-1.1-25.4-1.4l-24.6-.3-3.2-1.5c-4.3-2-7.3-4.9-9.4-8.9l-1.6-3.3-.2-21.1c-.1-11.7-.2-21.9-.4-22.5-.6-2.5-2.8-3-13.3-3-5.3 0-9.6-.1-9.6-.3s5.2-10.1 11.6-22l11.6-21.7v-6.1c0-7.2 1.2-17.3 2.8-23 1.5-5.3 4.4-13 5.2-13.5.3-.2 35.7 11 78.7 24.8l78 25.2-.3 2.2c-.6 3.5-3.7 12.8-6.1 17.9-3 6.5-8.6 14.6-13.8 20.4l-4.3 4.7v81.2l1.4 1.4c1.8 1.8 3.9 1.8 5.7 0l1.4-1.4V166l3.9-4.5c10.6-12.3 17.9-27.6 20.9-43.5 1.6-8.6 1.5-26.2-.3-34.3-7.9-36.9-35.2-64.3-71.9-72.1-7.4-1.7-24.3-2.1-31.5-.9m22.5 8.3c5.6.6 14.2 2.6 17.8 4l2 .9-2.6 1.6c-1.4.9-10.8 6.8-20.8 13.1L128.8 50l-6.3-13.6c-4.6-10-6.1-13.8-5.6-14.1 1.1-.7 10.3-2.7 14.7-3.2 6.1-.8 12.9-.8 19-.1m-36.2 20.5c3.5 7.6 6.4 14.1 6.5 14.5.2.8-19.6 13.7-21 13.7s-29.1-9.1-29.1-9.6c0-.2 1.3-2.3 2.9-4.7 4.1-5.9 15.1-16.6 21-20.5 4.8-3.1 12-7.2 12.9-7.2.2 0 3.3 6.2 6.8 13.8m69.3-9.5c6.4 3.7 17.3 12.7 16.4 13.5-.1.2-13.6 8.6-30 18.8l-29.7 18.6-4.1-1.3c-15.7-5-25.3-8.2-25.1-8.3.2-.2 68.7-43.3 68.9-43.4.1.1 1.7 1 3.6 2.1m26.7 25.3c6.2 9.3 10.6 20.2 12.8 31.2 1.1 5.6 1.8 20.7 1.1 21.2-.3.2-5.3-1.3-11.3-3.2l-10.7-3.5-8.6-18.7c-6.1-13.3-8.5-18.8-8-19.2 3.5-2.4 20.2-12.8 20.7-12.8.2-.2 2.1 2.2 4 5m-26.1 27.2c3.6 7.8 6.4 14.3 6.2 14.4-.2.2-33-10.3-38.4-12.2-.7-.2 23.9-16.2 25.1-16.3.4-.1 3.5 6.3 7.1 14.1"></path>
            <path d="M78.7 103.7c-5.4 3.6-6.5 10.3-2.4 15.2 2.1 2.4 4.3 3.4 7.6 3.4 10.8 0 14.1-14 4.4-19.1-2.5-1.3-7.4-1.1-9.6.5"></path>
        </svg>
    );
}

export type PickupReasonItem = {
    value: HotelPickupReasons;
    component: () => IconType;
    hover: string;
    bg: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
};

export type PickupReasonList = PickupReasonItem[];

export const pickupReasons: PickupReasonList = [
    {
        label: "Operasyon",
        value: HotelPickupReasons.OPERATION,
        component: () => TbStethoscope,
        ...softColors.blue,
        tooltip: {
            title: "Operasyon",
            description: "Hastanın operasyon işlemleri yapılacaktır.",
        },
    },

    {
        label: "Bandaj",
        value: HotelPickupReasons.BANDAGE,
        component: () => BandageHead,
        ...softColors.purple,
        tooltip: {
            title: "Bandaj",
            description: "Hastanın bandaj işlemi yapılacaktır.",
        },
    },

    {
        label: "Rhino Medical",
        value: HotelPickupReasons.RHINO_MEDICAL,
        component: () => TbFaceMask,
        ...softColors.teal,
        tooltip: {
            title: "Rhino Medical",
            description: "Hastanın rinoplasti işlemleri yapılacaktır.",
        },
    },

    {
        label: "Yes Smile",
        value: HotelPickupReasons.YES_SMILE,
        component: () => TbDental,
        ...softColors.pink,
        tooltip: {
            title: "Yes Smile",
            description: "Hastanın diş işlemleri yapılacaktır.",
        },
    },

    {
        label: "Diğer",
        value: HotelPickupReasons.OTHER,
        component: () => TbHeartbeat,
        ...softColors.brown,
        tooltip: {
            title: "Diğer",
            description: "Hastane işlemleri için getirilecektir.",
        },
    },
];
